(function () {
  'use strict';

  angular.module('sempraWebapp').factory('dailyFinancesStore', dailyFinancesStoreFactory);

  /** @ngInject */
  function dailyFinancesStoreFactory (dispatcher, EventEmitter, dailyFinancesActions, ActionTypesEnum) {
    var DailyFinancesStore = new EventEmitter(),
      dailyFinancesImmutable = null;

    DailyFinancesStore.events = Object.freeze({
      CHANGE: 'change'
    });

    DailyFinancesStore.getDailyFinances = function () {
      return dailyFinancesImmutable !== null
        ? dailyFinancesImmutable.toJSON()
        : null;
    };

    DailyFinancesStore.getDailyFinancesBySerialNumber = function (deviceSerialNumber) {
      if (dailyFinancesImmutable === null) {
        return null;
      }

      var result = dailyFinancesImmutable.toJSON().find(function (deviceJson) {
        return deviceJson.deviceSerial === deviceSerialNumber;
      });

      return result ? result : null;
    };

    DailyFinancesStore.dispatchToken = dispatcher.register(function (actionData) {
      switch (actionData.type) {
        case ActionTypesEnum.GET_DAILY_FINANCES:
              dailyFinancesImmutable = Immutable.fromJS(actionData.payload);
              DailyFinancesStore.emit(DailyFinancesStore.events.CHANGE);
      }
    });

    dailyFinancesActions.getDailyFinances();

    return DailyFinancesStore;
  }
})();
